import {Action} from '@ngrx/store';
import {type} from '../store.util';

export const StandaloneActionTypes = {
    RESET_STANDALONE_STORE: type('[standalone] Reset standalone store done'),
    FIRST_TIME_SYNC_DONE: type('[standalone] First time sync done'),
    NOTIFY_USER_FOR_CMC_VERSION_CHANGE: type('[standalone] show notification for CMC version change'),
    NOTIFY_USER_FOR_STANDARD_VERSION_CHANGE: type('[standalone] show notification for standard version change'),
    REMOVE_COLLECTION_FROM_CMC_SYNC_STATUS: type('[standalone] remove collections from CMC sync status'),
    UPDATE_COLLECTION_SYNC_STATUS_ACTION: type('[standalone] Update collections sync status action'),
    CMC_PRODUCTS_SYNC_DONE: type('[standalone] CMC Products sync done'),
    CMC_CLASSIFICATIONS_SYNC_DONE: type('[standalone] CMC Classifications sync done'),
    SET_CURRENT_CMC_VERSION: type('[standalone] Current CMC Version'),
    SET_CURRENT_STANDARD_VERSION: type('[standalone] Current Standard Version'),
    SET_CURRENT_PARAMETER_VERSION: type('[standalone] Current Parameter Version'),
    SET_QUOTE_COLLECTION_CHECKPOINT: type('[standalone] Set quote collection checkpoint ( date )'),
};export class ResetStandaloneStore implements Action {
    public type: string = StandaloneActionTypes.RESET_STANDALONE_STORE;
    constructor() {
    }
}

export class FirstTimeSyncDone implements Action {
    public type: string = StandaloneActionTypes.FIRST_TIME_SYNC_DONE;
    constructor() {
    }
}

export class NotifyUserForCmcVersionChange implements Action {
    public type: string = StandaloneActionTypes.NOTIFY_USER_FOR_CMC_VERSION_CHANGE;

    constructor(public notify: boolean) {
    }
}

export class NotifyUserForStandardVersionChange implements Action {
    public type: string = StandaloneActionTypes.NOTIFY_USER_FOR_STANDARD_VERSION_CHANGE;

    constructor(public notify: boolean) {
    }
}

export class RemoveCollectionsFromCmcSyncStatus implements Action {
    public type: string = StandaloneActionTypes.REMOVE_COLLECTION_FROM_CMC_SYNC_STATUS;

    constructor(public keys: string[]) {
    }
}

export class UpdateCollectionSyncStatusAction implements Action {
    public type: string = StandaloneActionTypes.UPDATE_COLLECTION_SYNC_STATUS_ACTION;

    constructor(public collectionName: string, public status: 'IN_PROGRESS' | 'DONE', public lastSyncDate?: Date) {
    }
}

export class CmcProductsSyncDoneAction implements Action {
    public type: string = StandaloneActionTypes.CMC_PRODUCTS_SYNC_DONE;

    constructor(public version: string) {
    }
}

export class CmcClassificationsSyncDoneAction implements Action {
    public type: string = StandaloneActionTypes.CMC_CLASSIFICATIONS_SYNC_DONE;

    constructor(public version: string) {
    }
}

export class CurrentCmcVersionAction implements Action {
    public type: string = StandaloneActionTypes.SET_CURRENT_CMC_VERSION;

    constructor(public version: string) {
    }
}

export class CurrentStandardVersionAction implements Action {
    public type: string = StandaloneActionTypes.SET_CURRENT_STANDARD_VERSION;

    constructor(public version: string) {
    }
}

export class CurrentParameterVersionAction implements Action {
    public type: string = StandaloneActionTypes.SET_CURRENT_PARAMETER_VERSION;

    constructor(public version: string) {
    }
}

export class QuoteCollectionCheckpointAction implements Action {
    public type: string = StandaloneActionTypes.SET_QUOTE_COLLECTION_CHECKPOINT;

    constructor(public quoteCollectionCheckPoint: Date) {
    }
}




export type StandaloneActions =
    FirstTimeSyncDone |
    NotifyUserForCmcVersionChange |
    NotifyUserForStandardVersionChange |
    UpdateCollectionSyncStatusAction |
    CmcProductsSyncDoneAction |
    CmcClassificationsSyncDoneAction |
    CurrentCmcVersionAction |
    CurrentStandardVersionAction |
    CurrentParameterVersionAction |
    RemoveCollectionsFromCmcSyncStatus|
    QuoteCollectionCheckpointAction
    ;

